import React from 'react';

export const Bagage = ({ size = 24, color = '#636363' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.93063 19.561C8.3934 19.561 7.95789 19.9965 7.95789 20.5337C7.95789 21.071 8.3934 21.5065 8.93063 21.5065C9.46787 21.5065 9.90338 21.071 9.90338 20.5337C9.90338 19.9965 9.46787 19.561 8.93063 19.561ZM10.9579 20.5337C10.9579 21.6533 10.0503 22.561 8.93063 22.561C7.81101 22.561 6.90338 21.6533 6.90338 20.5337C6.90338 19.4141 7.81101 18.5065 8.93063 18.5065C10.0503 18.5065 10.9579 19.4141 10.9579 20.5337Z"
      fill="#636363"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0691 19.5611C14.5319 19.5611 14.0964 19.9966 14.0964 20.5338C14.0964 21.0711 14.5319 21.5066 15.0691 21.5066C15.6064 21.5066 16.0419 21.0711 16.0419 20.5338C16.0419 19.9966 15.6064 19.5611 15.0691 19.5611ZM17.0964 20.5338C17.0964 21.6535 16.1887 22.5611 15.0691 22.5611C13.9495 22.5611 13.0419 21.6535 13.0419 20.5338C13.0419 19.4142 13.9495 18.5066 15.0691 18.5066C16.1887 18.5066 17.0964 19.4142 17.0964 20.5338Z"
      fill="#636363"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25574 7.70549C5.25574 6.38718 6.32444 5.31848 7.64275 5.31848H16.3581C17.6764 5.31848 18.7451 6.38718 18.7451 7.70549V17.354C18.7451 18.6723 17.6764 19.741 16.3581 19.741H7.64275C6.32444 19.741 5.25574 18.6723 5.25574 17.354V7.70549ZM7.64275 6.81848C7.15287 6.81848 6.75574 7.21561 6.75574 7.70549V17.354C6.75574 17.8438 7.15287 18.241 7.64275 18.241H16.3581C16.8479 18.241 17.2451 17.8438 17.2451 17.354V7.70549C17.2451 7.21561 16.8479 6.81848 16.3581 6.81848H7.64275Z"
      fill="#636363"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33923 1.96655C8.33923 1.55234 8.67502 1.21655 9.08923 1.21655H14.9106C15.3249 1.21655 15.6606 1.55234 15.6606 1.96655C15.6606 2.38077 15.3249 2.71655 14.9106 2.71655H9.08923C8.67502 2.71655 8.33923 2.38077 8.33923 1.96655Z"
      fill="#636363"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7731 1.28577C11.1873 1.28577 11.5231 1.62155 11.5231 2.03577V5.63951C11.5231 6.05372 11.1873 6.38951 10.7731 6.38951C10.3589 6.38951 10.0231 6.05372 10.0231 5.63951V2.03577C10.0231 1.62155 10.3589 1.28577 10.7731 1.28577Z"
      fill="#636363"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2277 1.28577C13.6419 1.28577 13.9777 1.62155 13.9777 2.03577V5.63951C13.9777 6.05372 13.6419 6.38951 13.2277 6.38951C12.8135 6.38951 12.4777 6.05372 12.4777 5.63951V2.03577C12.4777 1.62155 12.8135 1.28577 13.2277 1.28577Z"
      fill="#636363"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.79407 8.8396H15.2066V10.3396H8.79407V8.8396Z" fill="#007E47" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.79407 11.8579H15.2066V13.3579H8.79407V11.8579Z" fill="#007E47" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.79407 14.877H15.2066V16.377H8.79407V14.877Z" fill="#007E47" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Bagage.icon.jsx